import { Component, HostBinding, Input, OnDestroy, ViewChild, ViewEncapsulation } from '@angular/core';
import { Observable, fromEvent } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { BreakpointObserver } from '@angular/cdk/layout';
import { BREAKPOINT_WIDTH, SidePanelContentService } from '@galaxy/crm/static';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';
import { MatDrawerContainer, MatDrawerContent, MatDrawer } from '@angular/material/sidenav';
import { NgSwitch, NgSwitchCase, NgTemplateOutlet, NgIf, NgSwitchDefault, NgClass, AsyncPipe } from '@angular/common';
import { SidenavContentComponent } from './side-panel/crm-sidenav-content.component';

enum Layout {
  MOBILE = 'MOBILE',
  TABLET = 'TABLET',
  DESKTOP = 'DESKTOP',
}

@Component({
  selector: 'crm-three-panel-page',
  templateUrl: './three-panel-page.component.html',
  styleUrls: ['./three-panel-page.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    MatDrawerContainer,
    MatDrawerContent,
    NgSwitch,
    NgSwitchCase,
    MatTabGroup,
    MatTab,
    MatTabLabel,
    NgTemplateOutlet,
    NgIf,
    NgSwitchDefault,
    MatDrawer,
    NgClass,
    SidenavContentComponent,
    AsyncPipe,
  ],
})
export class ThreePanelPageComponent implements OnDestroy {
  @HostBinding('class.crm-three-panel-page') public true = 1;
  @Input({ required: true }) leftPanelTitle = '';
  @Input({ required: true }) centerPanelTitle = '';
  @Input() rightPanelTitle = '';
  @Input() showRightPanel = true;
  @ViewChild('mobileTab') mobileTab!: MatTabGroup;

  TABLET_BREAKPOINT = `(min-width: ${BREAKPOINT_WIDTH.MOBILE}) and (max-width: ${BREAKPOINT_WIDTH.TABLET})`;
  MOBILE_BREAKPOINT = `(max-width: ${BREAKPOINT_WIDTH.MOBILE})`;

  Layout = Layout;
  layoutState$: Observable<Layout>;

  sidenavOpen$: Observable<boolean>;
  mobile$: Observable<boolean>;

  mobileQuery: MediaQueryList;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly sidePanelContent: SidePanelContentService,
    private readonly media: MediaMatcher,
  ) {
    this.layoutState$ = this.breakpointObserver.observe([this.TABLET_BREAKPOINT, this.MOBILE_BREAKPOINT]).pipe(
      map((resp) => {
        if (resp.breakpoints[this.MOBILE_BREAKPOINT]) {
          return this.Layout.MOBILE;
        }
        if (resp.breakpoints[this.TABLET_BREAKPOINT]) {
          return this.Layout.TABLET;
        }
        return this.Layout.DESKTOP;
      }),
    );

    this.mobileQuery = this.media.matchMedia(this.MOBILE_BREAKPOINT);
    this.mobile$ = fromEvent(window, 'resize').pipe(
      map(() => this.mobileQuery.matches),
      distinctUntilChanged(),
    );
    this.sidenavOpen$ = this.sidePanelContent.getContent().pipe(map((c) => !!c));
  }

  ngOnDestroy(): void {
    this.sidePanelContent.clearContent();
  }
}
